<script setup lang="ts">
import { computed, type PropType } from 'vue'
import { useAuthStore } from '@/onenetwork/stores/onenetwork.store.auth.ts'
import _ from 'lodash'

const props = defineProps({
  perm: {
    type: [String, Array] as PropType<string | string[]>,
    default: '',
  },
  action: {
    type: String,
    default: 'hide',
  }
})

const AuthStore = useAuthStore()

const allow = computed(() => {
  if(props.perm == '*') return true
  if(typeof props.perm == 'string') {
    if(AuthStore.user?.permissions && AuthStore.user?.permissions.includes(props.perm)) return true;
  }
  if(typeof props.perm !== 'string') {
    if(_.intersection(props.perm, AuthStore?.user?.permissions).length > 0) return true;
  }
  return false
})
</script>

<template>
  <template v-if="props.action == 'hide'">
    <template v-if="allow">
      <slot></slot>
    </template>
  </template>
  <template v-if="props.action == 'warning'">
    <template v-if="allow">
      <slot></slot>
    </template>
    <template v-else>Fobidden access</template>
  </template>

</template>

<style scoped>

</style>
